import { RedisProviderCategoryAttributeRootInterface } from '../../../core/interfaces/categories/provider-category-attributes-interface';
import {
  AttributeInterface,
  ProviderProductInterface,
} from '../../../core/interfaces/product/product';

export const prepareAttributes = (
  attributeList: RedisProviderCategoryAttributeRootInterface[],
  providerProduct: ProviderProductInterface
) => {
  if (providerProduct.Attributes.length > 0) {
    providerProduct.Attributes = attributeCheckWithMarketplace(
      attributeList,
      providerProduct
    );

    attributeList.map((attribute) => {
      const found = providerProduct.Attributes.find(
        (f) => f.Code === attribute.Code
      );

      if (found) {
        attribute.Value = found.Value;
        attribute.IsVariant = found.IsVariant ?? false;
        attribute.IsFaulty = false;
      }
    });
  } else {
    providerProduct.Attributes = attributeList.map((f) => {
      return {
        Code: f.Code,
        Name: f.Name,
        Value: f.Value ?? '',
        MultiSelect: (f.Details && f.Details.length) > 0,
        Compulsory: f.IsMandotary,
        CategoryId: f.CategoryCode,
        IsVariant: f.IsVariant,
        Values: f.Values,
        Details: f.Details,
        IsFaulty: false,
      };
    });
  }
};

export const attributeCheckWithMarketplace = (
  attributeList: RedisProviderCategoryAttributeRootInterface[],
  providerProduct: ProviderProductInterface
): AttributeInterface[] => {
  const tempAttributes: AttributeInterface[] = [];
  providerProduct.Attributes.map((attribute) => {
    const found = attributeList.find(
      (f) => f.Code === attribute.Code
    );
    if (found) {
      const tempAttribute: AttributeInterface = {
        Code: attribute.Code,
        Name: attribute.Name,
        Value: attribute.Value ?? '',
        MultiSelect: (attribute.Details && attribute.Details.length) > 0,
        CategoryId: attribute.CategoryId,
        Values: attribute.Values,
        Details: attribute.Details ?? found.Details,
        IsVariant: found.IsVariant,
        Compulsory: found.IsMandotary,
        IsFaulty: found.IsFaulty ?? attribute.IsFaulty,
      };
      tempAttributes.push(tempAttribute);
    }
  });

  return tempAttributes;
};
